<template>
  <v-layout wrap class="mx-3 mt-2">
    <v-card>
      <v-card-title>
        <h1>Title: {{project.title}}</h1>
        <v-spacer></v-spacer>
        <v-btn flat class="right" color="primary" @click="showRatingModal">Rate Project</v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <p class="font-weight-bold">Description: <div v-html="project.description"></div></p>
          </v-flex>
          <v-flex xs12 sm12>
            <h4>Project Status: <span class="font-weight-regular">{{project.status}}</span></h4>
          </v-flex>
          <v-flex xs12 sm12>
            <h4>Category: <span class="font-weight-regular">{{project.category}}</span></h4>
          </v-flex>
          <v-flex xs12 sm12 v-if="project.location">
            <h4>Location: <span class="font-weight-regular">{{project.location.locationName}}</span></h4>
          </v-flex>
          <v-flex xs12 sm12>
            <h4>Posted On: <span class="font-weight-regular">{{project.createdAt | moment("DD MMMM YYYY") }}</span></h4>
          </v-flex>
          <v-flex xs12 sm12 v-if="project.videos">
            <hr>
            <label>Videos</label>
          </v-flex>
          <v-flex v-if="project.videos"  xs12 sm3 v-for="(video, index) in project.videos" v-bind:key="index">
            <video :src="`${host}/uploads/video_projects/video/${video}`" style="max-width:100%; height:auto" controls=""></video>
          </v-flex>

        <v-flex xs12 class="pa-2" v-if="reviews && reviews.length>=1">
          <h5 class="mb-3">Reviews ({{reviewAmount}})</h5>
          <v-layout wrap v-if="reviews.length>=1">
            <v-flex xs12 v-for="review in reviews" v-bind:key="review._id" class="mb-4">
              <span v-if="review.sonkoId" class="green--text text--darken-1">{{review.sonkoId.firstName}} {{review.sonkoId.lastName}}</span>
              <span class="green--text text--darken-1" v-else>{{review.username}}</span>
              <br>
              <i>{{review.review}}</i>
              <br>
              <v-rating
                v-bind:value="Math.round(review.rating)"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                half-increments
                hover
                readonly
              ></v-rating>
            </v-flex>
            <v-flex>
              <v-pagination 
                v-model="currentPage"
                :length="Math.ceil(reviewAmount/perPage)"
                @input="onPageChange"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>

    <!-- rating modal -->
    <v-dialog v-model="ratingModal" max-width="600px">
      <v-card>
        <v-toolbar color="green" flat dense dark>
          <v-toolbar-title class="title">Rate Project</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click.native="ratingModal=false">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-rating
                v-model="rating"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                half-increments
                hover
              ></v-rating>
            </v-flex>
            <v-flex xs12>
              <v-textarea v-model="review" label="Write a review"></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-btn color="green" small dark @click="saveReview">
                <v-icon>save</v-icon>save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- rating modal -->

    <!-- image modal -->
      <v-dialog v-model="imageDialog" max-width="1200px">
        <v-card>
          <v-toolbar flat dense color="light-blue" dark>
            <v-toolbar-title class="title">Image preview</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="mb-2" @click.native="closeImage">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <img class="modal-img" :src="`${host}/uploads/video_projects/${currentImage}`">
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of image modal -->      

    <app-snackbar ref="mySnackbar"></app-snackbar>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import LightBox from 'vue-image-lightbox'
export default {
  props: {
    project: {
      type: Object,
      default: {}
    },
    coverMedia: {
      type: Array,
      default: []
    }
  },
  components: {LightBox},
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  data() {
    return {
      rating: 0.0,
      review: null,
      reviews: [],
      ratingModal: false,
      imageDialog: false,
      currentImage: null,
      reviewAmount: 0,
      currentPage: typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1,
      perPage: 8,
    };
  },
  watch: {
    "$route.params.id": {
      handler: "projectReviews",
      immediate: true
    }
  },
  methods: {
    showImage(img) {
      this.currentImage = img;
      this.imageDialog = true;
    },
    closeImage() {
      this.imageDialog = false;
    },
    showRatingModal() {
      this.ratingModal = true;
    },
    saveReview() {
      if(this.rating <= 0) {
        this.$refs.mySnackbar.show("Please give an X/5 Stars Rating", "red");
      } else if (this.review == null) {
        this.$refs.mySnackbar.show("Please fill in review", "red");
      } else {
        const data = {
          rating: this.rating,
          review: this.review,
          projectId: this.project._id,
          expertId: this.project.userId,
          sonkoId: this.user._id
        };

        const self = this;
        const res = this.$store
          .dispatch("post", { url: "/review/videoproject", data })
          .then(res => {
            self.rating = 0.0;
            self.$refs.mySnackbar.show("Review Successful", "blue");
            self.ratingModal = false;
          });
      }
    },
    projectReviews(id) {
      let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
      const self = this;
      const res = this.$store
        .dispatch("get", "/review/videoproject/"+ id+"/"+cPage)
        .then(res => {
          self.reviews = res.reviews;
          self.reviewAmount = res.amount;
          self.currentPage = cPage;
        });
    },
    back() {
      this.$router.push("/sonko/jobs/active");
    },
    onPageChange(page) {
      this.$router.push({query: {page: page}});
      this.projectReviews(this.$route.params.id);
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    },
    openCoverGallery(index) {
      this.$refs.coverlightbox.showImage(index)
    },
  },
  created() {
    
  }
};
</script>